var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaleicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/dollar-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15 27.5C21.9036 27.5 27.5 21.9036 27.5 15C27.5 8.09644 21.9036 2.5 15 2.5C8.09644 2.5 2.5 8.09644 2.5 15C2.5 21.9036 8.09644 27.5 15 27.5Z",
    stroke: "#393945",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer 2",
    d: "M17.4152 13.3325C17.2867 12.7263 17.0233 12.1568 16.6446 11.6663H19.1656C19.3866 11.6663 19.5985 11.5785 19.7547 11.4222C19.911 11.266 19.9987 11.0541 19.9987 10.8331C19.9987 10.6122 19.911 10.4003 19.7547 10.244C19.5985 10.0878 19.3866 10 19.1656 10H10.8343C10.6134 10 10.4015 10.0878 10.2452 10.244C10.089 10.4003 10.0012 10.6122 10.0012 10.8331C10.0012 11.0541 10.089 11.266 10.2452 11.4222C10.4015 11.5785 10.6134 11.6663 10.8343 11.6663H13.3337C13.8488 11.6684 14.3507 11.8296 14.7706 12.1279C15.1906 12.4261 15.5081 12.8469 15.6798 13.3325H10.8343C10.6134 13.3325 10.4015 13.4203 10.2452 13.5765C10.089 13.7328 10.0012 13.9447 10.0012 14.1656C10.0012 14.3866 10.089 14.5985 10.2452 14.7547C10.4015 14.911 10.6134 14.9988 10.8343 14.9988H15.6798C15.5081 15.4844 15.1906 15.9051 14.7706 16.2034C14.3507 16.5017 13.8488 16.6629 13.3337 16.665H10.8343C10.6528 16.6648 10.4761 16.7238 10.3312 16.8332C10.1863 16.9425 10.0811 17.0963 10.0316 17.2709C9.98207 17.4456 9.99097 17.6317 10.0569 17.8008C10.1229 17.97 10.2423 18.1129 10.397 18.208L17.062 22.3736C17.2498 22.4907 17.4764 22.5284 17.692 22.4784C17.9077 22.4284 18.0946 22.2948 18.2117 22.107C18.3288 21.9192 18.3665 21.6926 18.3165 21.4769C18.2665 21.2613 18.1329 21.0744 17.9451 20.9573L13.7161 18.3138C14.6068 18.2309 15.4472 17.864 16.1134 17.2671C16.7796 16.6702 17.2362 15.875 17.416 14.9988H19.1656C19.3866 14.9988 19.5985 14.911 19.7547 14.7547C19.911 14.5985 19.9987 14.3866 19.9987 14.1656C19.9987 13.9447 19.911 13.7328 19.7547 13.5765C19.5985 13.4203 19.3866 13.3325 19.1656 13.3325H17.4152Z",
    fill: "#393945"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaleicon);
export default __webpack_public_path__ + "static/media/saleicon.e0959685.svg";
export { ForwardRef as ReactComponent };